import { Box, Typography } from '@mui/material';

import { Card, Section, StatusChip } from './Card';
import { humanizeCode } from './format';

// Human label for a recommendation tag: the muscle group label wins, then the lift label.
const tagFor = (rec, exercises, muscleGroups) => {
  if (rec.muscleGroup) {
    const group = (muscleGroups || []).find((g) => g.key === rec.muscleGroup);
    return group?.label || humanizeCode(rec.muscleGroup);
  }
  if (rec.exerciseName) {
    const exercise = (exercises || []).find((e) => e.exerciseName === rec.exerciseName);
    return exercise?.label || humanizeCode(rec.exerciseName);
  }
  return null;
};

const List = ({ title, items, renderMark }) =>
  items?.length ? (
    <Box sx={{ mb: 2 }}>
      <Typography variant="h3" sx={{ fontSize: 16, fontWeight: 700, mb: 1 }}>
        {title}
      </Typography>
      <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0, display: 'grid', gap: 1 }}>
        {items.map((item) => (
          <Box component="li" key={item.id} sx={{ display: 'flex', gap: 1.5, fontSize: 15 }}>
            {renderMark(item)}
            <span>{item.text}</span>
          </Box>
        ))}
      </Box>
    </Box>
  ) : null;

const Recap = ({ recap, exercises, muscleGroups }) => {
  const recs = (recap?.recommendations || []).slice(0, 3);
  return (
    <Section title="Your trainer's recap" id="perf-recap">
      <Card>
        <List
          title="Wins"
          items={recap?.wins}
          renderMark={() => (
            <span aria-hidden="true" style={{ flexShrink: 0 }}>
              ✓
            </span>
          )}
        />
        <List
          title="Worth watching"
          items={recap?.watchOuts}
          renderMark={(item) =>
            item.severity === 'caution' ? (
              <Box sx={{ flexShrink: 0 }}>
                <StatusChip label="Heads up" tone="caution" />
              </Box>
            ) : (
              <span aria-hidden="true" style={{ flexShrink: 0 }}>
                •
              </span>
            )
          }
        />
        {recs.length > 0 && (
          <Box>
            <Typography variant="h3" sx={{ fontSize: 16, fontWeight: 700, mb: 1 }}>
              Next steps
            </Typography>
            <Box component="ol" sx={{ pl: 2.5, m: 0, display: 'grid', gap: 1.5 }}>
              {recs.map((rec) => {
                const tag = tagFor(rec, exercises, muscleGroups);
                return (
                  <li key={rec.id}>
                    <Typography sx={{ fontWeight: 600, fontSize: 15 }}>
                      {rec.title}
                      {tag && (
                        <Box
                          component="span"
                          sx={{ ml: 1, fontSize: 12, opacity: 0.8, border: '1px solid', px: 0.75 }}
                        >
                          {tag}
                        </Box>
                      )}
                    </Typography>
                    <Typography sx={{ fontSize: 14, opacity: 0.85 }}>{rec.detail}</Typography>
                  </li>
                );
              })}
            </Box>
          </Box>
        )}
      </Card>
    </Section>
  );
};

export default Recap;
